import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { BookOpen, ArrowRight } from 'lucide-react';
import usePageTitle from '../../hooks/usePageTitle';

const TABS = [
  { id: 'in_progress', label: 'In Progress' },
  { id: 'completed', label: 'Completed' },
];

const EmptyState = ({ message }) => (
  <div data-testid="no-courses-enrolled" className="cine-card p-12 md:p-16 text-center">
    <BookOpen className="w-12 h-12 text-zinc-700 mx-auto mb-6" />
    <p className="text-sm text-zinc-400 mb-8 leading-relaxed max-w-md mx-auto">{message}</p>
    <Link to="/courses" className="btn-cine-primary inline-flex">
      Browse Courses
      <ArrowRight className="w-4 h-4" />
    </Link>
  </div>
);

const DashboardOverview = () => {
  usePageTitle('My Learning');
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('in_progress');

  const firstName = user?.name?.split(' ')[0] || 'there';

  return (
    <div>
      <div data-testid="dashboard-welcome" className="mb-10">
        <h1 className="display-heading text-4xl md:text-5xl text-white mb-3">
          Welcome, <em>{firstName}.</em>
        </h1>
        <p className="text-sm text-zinc-400">
          Pick up where you left off or browse new programs in the catalog.
        </p>
      </div>

      <div className="flex gap-0 border-b border-white/10 mb-10" role="tablist">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.id}
            onClick={() => setActiveTab(tab.id)}
            data-testid={`tab-${tab.id}`}
            className={`px-6 py-3 text-xs font-semibold tracking-[0.15em] uppercase border-b-2 transition-colors -mb-px ${
              activeTab === tab.id
                ? 'border-[#C8102E] text-white'
                : 'border-transparent text-zinc-500 hover:text-zinc-300'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'in_progress' && (
        <EmptyState message="You don't have any courses in progress yet. Enroll in a program to start learning." />
      )}
      {activeTab === 'completed' && (
        <EmptyState message="Completed courses will appear here once you finish a program." />
      )}
    </div>
  );
};

export default DashboardOverview;
